export default function LoadingPlaceholder(props: { children: JSX.Element }) {
  return <div className="placeholder shimmer">{props.children}</div>;
}
